import { cloneDeep } from 'lodash';

const state = {
  list: [],
  industry: {},
  edit_industry: {}
};

const getters = {
  list: (state) => {
    return (state.list || []).map((x) => Object.assign(x, { popularity: x.popularity || {} }));
  },
  industry: (state) => {
    return state.industry || {};
  },
  edit_industry: (state) => {
    return state.edit_industry || {};
  }
};

const mutations = {
  SET_LIST(state, industries) {
    state.list = industries;
  },

  SET_INDUSTRY(state, item) {
    const industry = cloneDeep(item);
    if (!industry.popularity) {
      industry.popularity = { id: null };
    }
    state.industry = industry;
    state.edit_industry = industry;
    const index = state.list.findIndex((x) => x.id === item.id);
    if (index >= 0) {
      const existing = cloneDeep(state.list[index]);
      this._vm.$set(
        state.list,
        index,
        Object.assign(existing, industry, {
          publishedCount: existing.publishedCount,
          notPublishedCount: existing.notPublishedCount
        })
      );
    } else {
      state.list.push(industry);
    }
  },
  EDIT_INDUSTRY(state, item) {
    state.edit_industry = item;
  },
  SET_NOTES(state, item) {
    if (state.industry.id === item.referenceId) {
      this._vm.$set(state.industry, 'designNotes', item.notes);
      this._vm.$set(state.edit_industry, 'designNotes', item.notes);
    }
    const index = state.list.findIndex((x) => x.id === item.referenceId);
    if (index >= 0) {
      this._vm.$set(state.list[index], 'designNotes', item.notes);
    }
  }
};

const actions = {
  load({ commit }, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('industries/getAll', filter)
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  get({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`industries/get?id=${id}`)
        .then((response) => {
          commit('SET_INDUSTRY', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  create({ commit }, industry) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('industries/create', industry)
        .then((response) => {
          commit('SET_INDUSTRY', response.data);
          commit('lookup/ADD_INDUSTRY', response.data, { root: true });
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  update({ commit }, industry) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('industries/update', industry)
        .then((response) => {
          commit('SET_INDUSTRY', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  edit({ commit }, item) {
    commit('EDIT_INDUSTRY', item);
  },
  savePopularity({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`industries/savePopularity?id=${req.id}&popularityId=${req.popularityId}`)
        .then((response) => {
          commit('SET_INDUSTRY', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
